// Light & Map Texture
import * as THREE from "three";
import Experience from "../Experience.js";
import { RectAreaLightUniformsLib } from 'three/examples/jsm/lights/RectAreaLightUniformsLib.js';
export default class Environment {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("environment");
    }

    this.setSunLight(new THREE.Vector3(1, 1, 0));
    /* this.setSunLight(new THREE.Vector3(-4, 2, -2)); */
    this.setAmbientLight();
    this.setEnvironmentMap();
    RectAreaLightUniformsLib.init();
  /*   this.setSpotLight(new THREE.Vector3(1, 1.5, 0)); */
  }

  setAmbientLight() {
    this.ambientLight = new THREE.AmbientLight(0xffffff,1.8); // 1
    this.scene.add(this.ambientLight);
  }

  setSunLight(position) {
    this.sunLight =new THREE.DirectionalLight( 0xffffff, 1.3 ); // 1.6
    this.sunLight.castShadow = true;
    this.sunLight.position.set(1.066,1,-0.286);
    this.sunLight.shadow.camera.far = 50;
    this.sunLight.shadow.mapSize.set(512, 512);
    this.sunLight.shadow.normalBias = 0.1;
    /* this.sunLight.shadow.radius = 3; */
   /*  this.sunLight.position.copy(position); */
    this.scene.add(this.sunLight);

    // Debug
    if (this.debug.active) {
      this.debugFolder
        .add(this.sunLight, "intensity")
        .name("sunLightIntensity")
        .min(0)
        .max(10)
        .step(0.001);

      this.debugFolder
        .add(this.sunLight.position, "x")
        .name("sunLightX")
        .min(-5)
        .max(5)
        .step(0.001);

      this.debugFolder
        .add(this.sunLight.position, "y")
        .name("sunLightY")
        .min(-5)
        .max(5)
        .step(0.001);

      this.debugFolder
        .add(this.sunLight.position, "z")
        .name("sunLightZ")
        .min(-5)
        .max(5)
        .step(0.001);
    }
  }

  createWindowLight(position) {
    const spotLight = new THREE.RectAreaLight("#ffffff",6, 1, 0.5);
  
    spotLight.position.copy(position);

    const group = new THREE.Group();

    group.add(spotLight);

    group.add( new RectAreaLightHelper( spotLight ) );


    // Debug
    if (this.debug.active) {
      this.debugFolder
        .add(this.spotLight, "intensity")
        .name("spotLightIntensity")
        .min(0)
        .max(10)
        .step(0.001);

      this.debugFolder
        .add(this.spotLight.position, "x")
        .name("spotLightX")
        .min(-5)
        .max(5)
        .step(0.001);

      this.debugFolder
        .add(this.spotLight.position, "y")
        .name("spotLightY")
        .min(-5)
        .max(5)
        .step(0.001);

      this.debugFolder
        .add(this.spotLight.rotation, "z")
        .name("spotLightZ")
        .min(-5)
        .max(5)
        .step(0.001);
        this.debugFolder
        .add(this.spotLight.rotation, "x")
        .name("rotation spotLightX")
        .min(-5)
        .max(5)
        .step(0.001);

      this.debugFolder
        .add(this.spotLight.rotation, "y")
        .name("rotation spotLightY")
        .min(-5)
        .max(5)
        .step(0.001);

      this.debugFolder
        .add(this.spotLight.rotation, "z")
        .name("rotation spotLightZ")
        .min(-5)
        .max(5)
        .step(0.001);
    }

    return group;
  }

  setEnvironmentMap() {
    this.environmentMap = {};
    this.environmentMap.intensity = 0.1; // 0.1
    this.environmentMap.texture = this.resources.items.environmentMapTexture; // les textures sont save dans items (dans Resources)
    this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace;

    this.scene.environment = this.environmentMap.texture;

    this.environmentMap.updateMaterials = () => {
      this.scene.traverse((child) => {
        if (
          child instanceof THREE.Mesh &&
          child.material instanceof THREE.MeshStandardMaterial
        ) {
          child.material.envMap = this.environmentMap.texture;
          child.material.envMapIntensity = this.environmentMap.intensity;
          child.material.needsUpdate = true;
        }
      });
    };
    this.environmentMap.updateMaterials();

    // Debug
    if (this.debug.active) {
      this.debugFolder
        .add(this.environmentMap, "intensity")
        .name("envMapIntensity")
        .min(0)
        .max(4)
        .step(0.001)
        .onChange(this.environmentMap.updateMaterials);
    }
  }
}
